module.exports = __webpack_public_path__ + "img/cover-casino-bg-mobile.bb10037f.jpg";